import {Component, OnInit} from '@angular/core';
import {DashboardService} from '../dashboard.service';
import {ApiService} from '../../core/http/api.service';
import {UtilsService} from '../../core/services/utils/utils.service';

@Component({
    selector: 'app-rating-categories',
    templateUrl: './rating-categories.component.html',
    styleUrls: ['./rating-categories.component.css'],
    standalone: false
})
export class RatingCategoriesComponent implements OnInit {
  categories: any[] = [];
  categoriesData: any;
  filter = '';
  type = '1';
  loading = false;
  pageLoading = true;
  loaders = Array(10).fill(0);

  constructor(
    private dashboardApi: DashboardService,
    private api: ApiService,
    private utils: UtilsService,
  ) {
  }

  ngOnInit(): void {
    this.getAllRatingCategories();
  }

  getAllRatingCategories(): void {
    this.loading = true;
    this.api.getRatingCategories(this.filter).subscribe((data) => {
      this.loading = false;
      const response = data?.response || {};
      this.categoriesData = response;
      const list = this.type === '1'
        ? (response.entity_rating_categories || [])
        : (response.nft_rating_categories || []);

      this.categories = (Array.isArray(list) ? list : [])
        .filter((item) => !!item)
        .map((item) => ({
          ...item,
          id: item.id || item._id || '',
          name: item.name || '',
          icon: item.icon || '',
          category: Array.isArray(item.category) ? item.category : [],
        }));
      this.pageLoading = false;
    }, err => {
      this.loading = false;
      this.pageLoading = false;
    });
  }

  removeRatingCategory(id): void {
    this.dashboardApi.removeRatingCategory(id).subscribe((data) => {
      this.getAllRatingCategories();
    });
  }

  handleCopyToClipboard(str: any = ''): void {
    this.utils.copyToClipboard(str);
    this.utils.toastSuccess('ID copied to your clipboard successfully');
  }

}
